// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FooterButton__right___z0pLv {
    display: flex;
    gap: var(--space-xs);
}

.FooterButton__minimized___Q2YK1 {
    align-items: end;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Template/Footer/FooterButton/FooterButton.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".right {\n    display: flex;\n    gap: var(--space-xs);\n}\n\n.minimized {\n    align-items: end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"right": `FooterButton__right___z0pLv`,
	"minimized": `FooterButton__minimized___Q2YK1`
};
export default ___CSS_LOADER_EXPORT___;
